// Payroll data accessor — always the live gateway client (database-backed).
// There is no offline mock: everything the payroll UI shows comes from the API.
import type { PayrollApiContract } from './contract';
import { payrollApiLive } from './live';

export const payrollApi: PayrollApiContract = payrollApiLive;
export type { PayrollApiContract } from './contract';
